module.exports = __webpack_public_path__ + "img/brushes_en.ef32e1c.jpg";